export default __webpack_public_path__ + "static/header-477ae81b809029c8e937d07ec5f5202a.png";